import { CommentHeaderButton } from '@components/ArtBoard/Threads/components/CommentHeaderButton'
import { TinyDropdownMenu } from '@octopus-do/octopus-storybook'
import { EllipsisVertical } from '@octopus-do/octopus-storybook/icons'
import { forwardRef } from 'react'

interface Props {
  className?: string
}

export const CommentSettingsTrigger = forwardRef<HTMLButtonElement, Props>(
  ({ className }, ref) => {
    const { active, toggle } = TinyDropdownMenu.useTrigger()
    return (
      <CommentHeaderButton
        className={className}
        ref={ref}
        onClick={toggle}
        active={active}
      >
        <EllipsisVertical height="16px" width="16px" />
      </CommentHeaderButton>
    )
  }
)
